import { render, staticRenderFns } from "./ListaCargadoresDialogComponent.vue?vue&type=template&id=ec1d52a6&scoped=true"
import script from "./ListaCargadoresDialogComponent.vue?vue&type=script&lang=js"
export * from "./ListaCargadoresDialogComponent.vue?vue&type=script&lang=js"
import style0 from "./ListaCargadoresDialogComponent.vue?vue&type=style&index=0&id=ec1d52a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec1d52a6",
  null
  
)

export default component.exports